import type { ReactNode } from 'react';
import { Badge, Check } from 'lucide-react';

import { PLAN_FAMILY, type PlanFamily } from '@/types/insurance.type.ts';

export function FoundCoverageBanner({ children }: { children: ReactNode }) {
  return (
    <div className="mb-8 flex min-h-10 w-full items-center justify-center gap-[5px] rounded-sm bg-[#eaf6f5] p-2 text-sm leading-[1.4] text-black sm:mb-10">
      <span className="relative size-6 shrink-0" aria-hidden="true">
        <Badge
          className="fill-spruce-500 text-spruce-500 absolute inset-0 size-6"
          strokeWidth={0}
        />
        <Check
          className="absolute top-1/2 left-1/2 size-3.5 -translate-x-1/2 -translate-y-1/2 text-white"
          strokeWidth={3}
        />
      </span>
      <span className="min-w-0 flex-1">{children}</span>
    </div>
  );
}

export function getFoundBaseCoverageLabel(family: PlanFamily, state?: string): string {
  if (family === PLAN_FAMILY.MEDICARE) return 'We found your active Original Medicare';
  if (state === 'FL') return 'We found your active Florida Medicaid (Gold Card)';
  if (state === 'NY') return 'We found your active New York Medicaid';
  return 'We found your active Medicaid';
}
